import { h } from 'preact';
import React, { Component } from 'react';
import Switch from './Switch';
import { makeText, isActionAllowed } from '../../../util';

export default class Accordion extends Component {
  state = {
    open: false
  }
  toggleAccordion = e => {
    if (e === undefined || ['stack-toggle', 'opener', 'expand'].some(cssClass => e.target.className.includes(cssClass))) return;
    const panel = this.panel;
    const open = !this.state.open;
    this.setState({ open });
    if (!open) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + 'px';
    }
  }
  shouldComponentUpdate(nextProps, nextState) {
    const panel = this.panel;
    const open = nextState.open;
    if (panel && open) {
      setTimeout(() => {
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }, 100);
    }
  }
  render() {
    const { dev, name, accessName, description, content, selected, toggle, child, value, language, titleContent, vendors, isCustom, locked, consentType, isApple, appleDataBrokerLetter, usePurModel} = this.props;
    const { open } = this.state;
    const Settings = this.props.settings || {};
    const accordionStyles = {
      ...Settings.accordionsSpacing,
      ...Settings.accordionsFont
    };
    const panelStyles = {
      ...Settings.panelSpacing,
      ...Settings.panelFont
    };

    const toggleText = makeText(Boolean(dev), Settings, 'toggleText', language);
    const toggleOffText = makeText(Boolean(dev), Settings, 'toggleOffText', language);
    const descriptionWithoutTag = description ? description.slice(3).slice(0, -4) : '';
    return (
      <div
        className="ccpa-stack"
        tabindex="0"
        title={accessName || 'Accordion'}
        onKeyDown={(e) => isActionAllowed(e.key) && this.toggleAccordion(e)}
      >
        <div className={isCustom ? 'stack-row custom' : 'stack-row'} style={{ position: 'relative' }}>
          <div
            className={open ? 'accordion active' : 'accordion'}
            style={accordionStyles}
            onClick={this.toggleAccordion}
          >
             <span className={open ? 'chevron up' : 'chevron down'} />
             {open && !titleContent ? <b>{name}</b> : name}
            {isApple && <span className="legend-key apple-broker" aria-hidden>{appleDataBrokerLetter}</span>}
            {titleContent ? titleContent : null}
          </div>
          {toggle && (
            <Switch
              accessName={(accessName + ' Toggle') || 'Accordion Toggle'}
              type={Settings.toggleType}
              color={Settings.toggleColor}
              colorActive={Settings.toggleActiveColor}
              offColor={Settings.toggleOffColor}
              offActiveColor={Settings.toggleOffActiveColor}
              text={toggleText}
              offText={toggleOffText}
              toggle={toggle}
              child={child}
              vendors={vendors}
              value={value}
              locked={locked}
              checked={ value.enabled }
              consentType={consentType}
            /> 
          )}
        </div>
        <div ref={c => this.panel = c} className="panel">
          <p style={{ ...panelStyles }}>
            {content ? React.cloneElement(content, { accordionOpen: open }) : descriptionWithoutTag}
          </p>
        </div>
      </div>
    );
  }
}